import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions, NgbModule, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { LocationServiceService } from '../../Model/LocationMaster/location-service.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { Subject } from 'rxjs';
import { MapShiftComponent } from '../map-shift/map-shift.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import moment from 'moment';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { DesignationWiseSummaryComponent } from '../designation-wise-summary/designation-wise-summary.component';

@Component({
  selector: 'app-location-master-new',
  standalone: true,
  imports: [NgbNavModule, NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule, LoaderComponent, JsonPipe],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './location-master-new.component.html',
  styleUrl: './location-master-new.component.scss'
})
export class LocationMasterNewComponent {
  @ViewChild('nav') nav!: NgbNav;
  active = 1;
  isDisabled: boolean = false;
  Detail = {
    ESS_SiteMasterId: '',
    SelecteType: 1,
    BranchId: null,
    UserId: null
  }
  Sitedatafrmview = {
    EditSData: false,
    SelectType: '',
    SiteMasterId: ''
  }
  SData: any[] = [];
  SData1: any[] = [];
  SData2: any[] = [];
  SData3: any[] = [];
  SData4: any[] = [];
  IndustrySeg = [] as any;
  ServiceType: any[] = [];
  RegionMaster: any[] = [];
  BranchMaster: any[] = [];
  CustomerGroup: any[] = [];
  BillingCustomer: any[] = [];
  FinancialBranch: any[] = [];
  Group: any[] = [];
  State: any[] = [];
  District: any[] = [];
  Taluka: any[] = [];
  ZoneMaster: any[] = [];
  SiteOwner: any[] = [];
  ReportTypeMaster: any[] = [];
  DesignationLoad: any[] = [];
  DutyLoad: any[] = [];
  Shift: any[] = [];
  ManPowerTable: any[] = [];
  SiteType: any[] = [];
  Channels: any[] = [];
  Banks: any[] = [];
  AttendanceThroughLoad: any[] = [];
  LeaveSalaryCycleLoad: any[] = [];
  LeaveSalaryPayoutLoad: any[] = [];
  PayoutBonusesCycleLoad: any[] = [];
  PayoutBonusLoad: any[] = [];
  GratuityLoad: any[] = [];
  UniformLoad: any[] = [];
  MinimumWageIndustryLoad: any[] = [];
  MinimumWageZoneLoad: any[] = [];
  WageStrutureLoad: any[] = [];
  Groups: any[] = [];
  SubGroups: any[] = [];
  FilteredSubGroups: any[] = [];

  SiteSubGroupMasterID = null as any;
  SiteGroupMasterID = null as any;

  IndustryId: any = null
  ServiceId: any = null;
  RegionId: any = null;
  BranchId: any = null;
  BranchName: string = '';
  CustGrpId: any = null;
  BillCustId: any = null;
  FinBranchid: any = null;
  ReportTypeId: any = null;
  GroupId: any = null;
  GroupName: string = '';
  Stateid: any = null;
  DistrictId: any = null;
  TalukaId: any = null;
  ZoneId: any = null;
  SiteOwnerId: any = null;
  Designation: string = '';
  DesignationId: any = null;
  DutyId: any = null;
  Duty: string = '';
  noOfEmpValue: number = 0;
  editMode: boolean = false;
  ProductDesp: string = '';
  Telephone: any = null;
  SiteCode: string = '';
  SiteName: any = null;
  Pincode: any = null;
  City: string = '';
  Address1: string = '';
  Address2: string = '';
  Compliance: string = 'Compliance';
  BillTypeValue: any = 'MB';
  BillType: string = 'Muster Billing';
  ContactPersonName: string = '';
  ContactPersonEmail: string = '';
  ContactPersonNo: string = '';
  BillDutyDivisionBy: number = 1;
  pfonbasicdaot: boolean = false //number = 0;
  AdminCharge: boolean = true// number = 1;
  attendence: boolean = false;
  Isactive: boolean = true;
  // salcalcDate: string = 'salMonth';
  // bilCalcDate: string = 'bilMonth';
  SalaryFrom: number = 1;
  SalaryTo: number = 0;
  BillingFrom: number = 1;
  BillingTo: number = 0;
  SalaryCalcDate: string = 'M';
  BillingCalcDate: string = 'M';
  WeeklyOffDivisionBy: number = 7;
  PfApplicable: boolean = true//number = 1;
  ESICApplicable: boolean = true;
  PTApplicable: boolean = true;
  LWFApplicable: boolean = true;
  IsMocked: number = 0;
  latitude: any = '';
  longitude: any = '';
  Accuracy: any = '';
  Altitude: any = '';
  IsAltitudeApplicable: boolean = false;
  AltitudeRadius: any = '';
  Heading: any = '';
  Radius: any = '';
  WorkOrderNumber: string = '';
  ClientSiteCode: string = '';
  WorkOrderDate: any = null;
  WorkOrderDateObj: any = null
  ValidTill: any = null
  ValidTillObj: any = null
  WorkOrderValue: any = null;
  ContractStartDate: any = null
  ContractStartDateObj: any = null;
  ContractValue: any = null;
  AnnualValue: any = null;
  Narration: string = '';
  AgreementType: any = null;
  NoOfAgreement: any = null;
  Tender: any = null;
  TenureofContract: any = null;
  MinimumEscalationClause: any = null;
  BillingName: string = '';
  RBIIndex: boolean = true; // number = 1;
  MinWages: boolean = true;
  PerIncGrowth: boolean = true;
  GuardBoardIndex: boolean = true;
  ManpowerCost: any = null;
  ManPowerValue: any = null;
  ManPowerValueAtactual: any = null;
  MachineryCost: any = null;
  MachineryOption: any = null;
  MachineryValue: any = null;
  ConsumableCost: any = null;
  consumoptvalue: any = null;
  consumablevalue: any = null;
  ManagementFees: any = null;
  MgmtFeesValue: any = null;
  uniformvalue: any = null;
  OtherChargesvalue: any = null;
  OtherValue: any = null;
  siteactive: any = null
  siteactiveObj: any = null;
  sitend: any = null;
  sitendObj: any = null
  NewIndustrySegment: string = '';
  SubServiceType: string = '';
  NewSubLocation1: string = '';
  NewSubLocation2: string = '';
  SiteTypeValue: string = 'New';
  // SiteType: string = 'New Site';
  MachineryChgVal: any = null;
  machinerycharge: any = null;
  MachineryChgType: string = '';
  MatChargvalue: any = null;
  MaterialChgType: string = '';
  MaterialChgVal: any = null;
  AreaSqFt: any = null;
  OperationTeamEmailId: string = '';
  CompNatureofWork: string = '';
  SalaryCalcOn: string = 'M';
  BillCalOn: string = 'M';
  salFixedDaysValue: number = 0;
  SalmonthDayvalue: number = 0;
  BllFixedDaysValue: number = 0;
  BillmonthValue: number = 0;
  Index: number = 0;


  PPUMachineryCost: any = null
  PPUBGCost: any = null
  PPUBusinessProvisionPercent: any = null
  PPUBusinessProvisionValue: any = null
  CISMarginValue: any = null
  Sitecount: any = null
  ManpowerStrength: any = null
  AttendanceDateValue: any = null
  SalaryDateValue: any = null
  SalaryPaymentDateValue: any = null
  BillingDateValue: any = null
  SiteTypeID: any = null

  public User: any = null;
  RETURN = {
    ReturnedSiteId: null,
    ReturnedSiteCode: null
  }
  ErrorCode: string = ''
  // FormName = [
  //   { Name: 'SiteMaster' },
  //   { Name: 'SiteLocationCalcMaster' }
  // ];
  // FormName: string[] = new Array("SiteMaster", "activatedeactivatesite");
  ResData: any;
  AllocationData: any[] = [];
  Date: any = null;

  IsInternalPOCApplicable: boolean = false;
  InternalPOCName = '';
  InternalPOCMobileNo = '';
  InternalPOCMailId = '';
  IsClientPOCApplicable: boolean = false;
  IsClientAttendanceInformationMail: boolean = false;
  ClientPOCName = '';
  ClientPOCMobileNo = '';
  ClientPOCMailId = '';
  SiteChannelId = null as any
  SiteOracleCode = '';
  SiteAlternateCode = '';
  SiteAgreementCopyAttachment: string = '';
  selectedFile: File | null = null;
  AttachmentUrl: any;
  SiteBankId = null as any;
  BankName = '';
  AccountNumber = '';
  IFSCcode = '';
  BankBranchName = '';
  SiteAttendanceThrough = null as any;
  SiteLeaveSalarCycle = null as any;
  SiteLeaveSalary = null as any;
  SitePayoutBonusesCycle = null as any;
  SitePayoutBonus = null as any;
  SiteGratuity = null as any;
  SiteUniforms = null as any;
  SiteIsUniformsDeposit = false;
  SiteMinimumWageIndustry = null as any;
  SiteMinimumWageZone = null as any;
  SiteMinimumWageStructure = null as any;
  BillToOption = false;
  SiteBillTo = 'Client';
  SiteShipTo = 'Client';
  SiteAutoMail = false;
  SitePlaceOfSupplyApplicable = false;
  SiteDefaultNarration = '';

  SiteOwnerName = '';
  SiteOwnerEmail = '';
  SiteOwnerNumber = '';

  checkboxChanged(event: any) {
    console.log(event.target.checked);
    this.BillToOption = event.target.checked;
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(private locationservice: LocationServiceService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private toast: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private comboload: ComboService,
    private utility: UtilityService,
    private siteadditionreduction: AdditionOfManpowerService,
  ) {
    this.common.getPageRights();
    this.common.CompanyParameter();
    this.User = this.sessionService.GetUserDetails();
    this.Detail.UserId = this.User.UserId;
    this.route.queryParams.subscribe(params => {
      this.Sitedatafrmview.EditSData = params['editMode'];
      this.Sitedatafrmview.SelectType = params['SelectType'];
      this.Sitedatafrmview.SiteMasterId = params["SiteMasterId"];
    });
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit(): void {
    this.ComboLoad('SiteTypeMaster');
    this.loadSiteData();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Date = this.dateFormate.parse(response.Table[0].RegistrationDate)
          if (this.siteactive == null || this.siteactive == '') {
            this.siteactive = this.dateFormate.parse(response.Table[0].RegistrationDate)
          }
          if (this.sitend == null || this.sitend == '') {
            this.sitend = this.dateFormate.parse(response.Table[0].RegistrationDate)
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  loadSiteData() {
    this.isDisabled = true
    this.locationservice.SiteComboLoad(this.Detail).subscribe({
      next: (data) => {
        this.IndustrySeg = data.IndustrySegmentMaster;
        this.ServiceType = data.ServiceTypeMaster;
        this.RegionMaster = data.RegionMaster;
        if (!this.common.CompanyParameterValue.CCCode) {
          this.BranchMaster = data.BranchMaster;
        }
        this.CustomerGroup = data.ClientGroupMaster;
        this.FinancialBranch = data.financialBranch;
        this.ReportTypeMaster = data.ReportTypeMaster;
        this.Group = data.GroupMaster;
        this.State = data.StateMaster;
        //this.ZoneMaster = data.ZoneMaster;
        //this.SiteOwner = data.siteowner;
        this.DesignationLoad = data.DesignationMaster;
        this.DutyLoad = data.DutyMaster;
        this.Channels = data.ChannelMaster;
        this.Banks = data.SiteBankMaster;
        this.AttendanceThroughLoad = data.AttendanceThrough;
        this.LeaveSalaryCycleLoad = data.LeaveSalarCycle;
        this.LeaveSalaryPayoutLoad = data.LeaveSalary;
        this.PayoutBonusesCycleLoad = data.PayoutBonusesCycle;
        this.PayoutBonusLoad = data.PayoutBonus;
        this.GratuityLoad = data.Gratuity;
        this.UniformLoad = data.Uniforms;
        this.MinimumWageIndustryLoad = data.MinimumWageIndustry;
        this.MinimumWageZoneLoad = data.MinimumWageZone;
        this.WageStrutureLoad = data.MinimumWageStructure;
        this.Groups = data.SiteGroupMaster;
        this.SubGroups = data.SiteSubGroupMaster;
        this.FilteredSubGroups = data.SiteSubGroupMaster;
        //this.Shift = data.ShiftMaster;  
        this.isDisabled = false
      },
      complete: () => {
        if (this.Sitedatafrmview.EditSData) {
          this.ProcessData();
        }
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }

  ProcessData() {
    this.isDisabled = true
    this.locationservice.SiteMasterLoad(this.Sitedatafrmview).subscribe(
      data => {
        if (data.Table) {
          this.SData = data.Table;
        }
        if (data.Table1) {
          this.SData1 = data.Table1;
        }
        if (data.Table2) {
          this.SData2 = data.Table2;
        }
        if (data.Table3) {
          this.SData3 = data.Table3;
        }
        if (data.Table4) {
          this.SData4 = data.Table4;
        }

        if (this.SData.length > 0) {
          const firstRow = this.SData[0];
          this.IndustryId = firstRow.IndustrySegmentID;
          this.ServiceId = firstRow.ServiceTypeID;
          this.RegionId = firstRow.RegionID;
          this.ComboLoad2('Branch');
          this.BranchId = firstRow.BranchID;
          this.Detail.BranchId = this.BranchId;
          this.locationservice.SiteComboLoad(this.Detail).subscribe({
            next: (data) => {
              this.SiteOwner = data.siteowner;
              this.ZoneMaster = data.ZoneMaster;
            },
            complete: () => {
              this.siteOwnerChange();
            },
            error: (error) => {
              this.isDisabled = false
              console.error('Error:', error);
            },
          });
          this.BranchName = firstRow.BranchName;
          this.CustGrpId = firstRow.ClientGroupId;
          this.locationservice.BillCustLoad({ SelectType: 1, ClientGroupMasterId: this.CustGrpId }).subscribe({
            next: (data) => {
              if (data.Table.length > 0) {
                this.BillingCustomer = data.Table;
              }
              else {
                this.BillingCustomer = [];
              }
            },
            complete: () => {
            },
            error: (error) => {
              this.isDisabled = false
              console.error('Error:', error);
            },
          });
          this.BillCustId = firstRow.MaxClientId;
          this.SiteCode = firstRow.SiteCode;
          this.SiteName = firstRow.SiteName;
          this.FinBranchid = firstRow.FinancialBranchID;
          this.GroupId = firstRow.GroupID;
          this.Address1 = firstRow.Address1;
          this.Address2 = firstRow.Address2;
          this.City = firstRow.City;
          this.Pincode = firstRow.PinCode;
          this.Telephone = firstRow.TelephoneNo;
          if (firstRow.BillType == 'Fixed Billing') {
            this.BillTypeValue = 'FB';
            this.BillType = 'Fixed Billing'
          }
          else if (firstRow.BillType == 'Muster Billing') {
            this.BillTypeValue = 'MB';
            this.BillType = 'Muster Billing'
          }
          else if (firstRow.BillType == "BillOnSalaryCTC") {
            this.BillTypeValue = 'BO';
            this.BillType = 'BillOnSalaryCTC'
          }
          this.NewIndustrySegment = firstRow.NewIndustrySegment;
          this.SubServiceType = firstRow.SubServiceType;
          this.NewSubLocation1 = firstRow.NewSubLocation1;
          this.NewSubLocation2 = firstRow.NewSubLocation2;
          this.OperationTeamEmailId = firstRow.OperationTeamEmailId;
          this.SiteOwnerId = firstRow.SiteOwnerID;
          this.RBIIndex = firstRow.RBIIndex //? 1 : 0;
          this.MinWages = firstRow.MinWages //? 1 : 0;
          this.pfonbasicdaot = firstRow.PFonBasicDAOT //? 1 : 0;
          this.AdminCharge = firstRow.IsAdminChargesApplicable// ? 1 : 0;
          this.PerIncGrowth = firstRow.PerIncGrowth //? 1 : 0;
          this.attendence = firstRow.OnlineAttendanceFreeze// ? 1 : 0;
          this.Isactive = firstRow.Active //? 1 : 0;
          this.ZoneId = firstRow.ZoneId;
          this.BillDutyDivisionBy = firstRow.BillDutyDivisionBy;
          this.WeeklyOffDivisionBy = firstRow.WeeklyOffDivideBy;
          this.AgreementType = firstRow.AgreementType;
          this.AnnualValue = firstRow.AnnualValue;
          this.BillingName = firstRow.BillingName;
          this.CompNatureofWork = firstRow.CompNatureofWork;
          this.Compliance = firstRow.Compliance
          this.ConsumableCost = firstRow.ConsumableCost;
          this.consumoptvalue = firstRow.ConsumableOption;
          this.consumablevalue = firstRow.ConsumableValue;
          this.uniformvalue = firstRow.UniformOption;
          this.ContactPersonEmail = firstRow.ContactPersonEmail;
          this.ContactPersonName = firstRow.ContactPersonName;
          this.ContactPersonNo = firstRow.ContactPersonTelNo;
          this.ContractStartDate = this.dateFormate.parse(firstRow.ContractStartDate);
          this.ValidTill = this.dateFormate.parse(firstRow.ValidTill)
          this.ContractValue = firstRow.ContractValue;
          this.ESICApplicable = firstRow.ESICApplicable; //? 1 : 0;
          this.LWFApplicable = firstRow.LWFApplicable;//? 1 : 0;
          this.PTApplicable = firstRow.PTApplicable, //? 1 : 0;
            this.PfApplicable = firstRow.PFApplicable,// ? 1 : 0;
            this.ClientSiteCode = firstRow.ClientSiteCode;
          this.GroupName = firstRow.GroupName;

          this.GuardBoardIndex = firstRow.GuardBoardIndex //? 1 : 0;
          this.MachineryCost = firstRow.MachineryCost;
          this.MachineryOption = firstRow.MachineryOption;
          this.MachineryValue = firstRow.MachineryValue;
          this.ManagementFees = firstRow.ManagementFees;
          this.ManpowerCost = firstRow.ManpowerCost;
          this.ManPowerValue = firstRow.ManpowerOption;
          this.ManPowerValueAtactual = firstRow.ManpowerValue;
          this.MgmtFeesValue = firstRow.MgmtFeesValue;
          this.MinimumEscalationClause = firstRow.MinimumEscalationClause;
          this.Narration = firstRow.Narration;
          this.NoOfAgreement = firstRow.NoOfAgreement;
          this.OtherChargesvalue = firstRow.OtherChargesOption;
          this.OtherValue = firstRow.OtherCharges;
          this.Tender = firstRow.Tender;
          this.ReportTypeId = firstRow.ReportTypeMasterID;
          this.sitend = this.dateFormate.parse(firstRow.SiteEndDate)
          this.siteactive = this.dateFormate.parse(firstRow.SiteStartDate)

          this.RegionId = firstRow.RegionMasterID;
          this.Stateid = firstRow.StateMasterId;
          this.ComboLoad('District');
          this.DistrictId = firstRow.DistrictMasterID;
          this.ComboLoad('Taluka')
          this.TalukaId = firstRow.TalukaMasterID;

          this.TenureofContract = firstRow.TenureOfContract;
          this.WorkOrderDate = this.dateFormate.parse(firstRow.WorkOrderDate)
          this.WorkOrderNumber = firstRow.WorkOrderNumber;
          this.WorkOrderValue = firstRow.WorkOrderValue;
          this.SiteTypeValue = firstRow.SiteType;

          this.PPUMachineryCost = firstRow.PPUMachineryCost;
          this.PPUBGCost = firstRow.PPUBGCost;
          this.PPUBusinessProvisionPercent = firstRow.PPUBusinessProvisionPercent;
          this.PPUBusinessProvisionValue = firstRow.PPUBusinessProvisionValue;
          this.CISMarginValue = firstRow.CISMarginValue;
          this.Sitecount = firstRow.SiteCount;
          this.ManpowerStrength = firstRow.ManpowerStrength;
          this.AttendanceDateValue = firstRow.AttendanceDateValue;
          this.SalaryDateValue = firstRow.SalaryDateValue;
          this.SalaryPaymentDateValue = firstRow.SalaryPaymentDateValue;
          this.BillingDateValue = firstRow.BillingDateValue;
          this.SiteTypeID = firstRow.SiteTypeID;
          this.IsInternalPOCApplicable = firstRow.IsInternalPOCApplicable;
          this.InternalPOCName = firstRow.InternalPOCName;
          this.InternalPOCMobileNo = firstRow.InternalPOCMobileNo;
          this.InternalPOCMailId = firstRow.InternalPOCMailId;
          this.IsClientPOCApplicable = firstRow.IsClientPOCApplicable;
          this.IsClientAttendanceInformationMail = firstRow.IsClientAttendanceInformationMail;
          this.ClientPOCName = firstRow.ClientPOCName;
          this.ClientPOCMobileNo = firstRow.ClientPOCMobileNo;
          this.ClientPOCMailId = firstRow.ClientPOCMailId;
          this.SiteChannelId = firstRow.SiteChannelId;
          this.SiteOracleCode = firstRow.SiteOracleCode;
          this.SiteAlternateCode = firstRow.SiteAlternateCode;
          this.SiteAgreementCopyAttachment = firstRow.SiteAgreementCopyAttachment;
          this.AttachmentUrl = 'https://webftp.maxus.co.in/PROD/SiteAgreementDetail/' + firstRow.SiteAgreementCopyAttachment;
          this.SiteBankId = firstRow.SiteBankId;
          this.SiteAttendanceThrough = firstRow.SiteAttendanceThrough;
          this.SiteLeaveSalarCycle = firstRow.SiteLeaveSalarCycle;
          this.SiteLeaveSalary = firstRow.SiteLeaveSalary;
          this.SitePayoutBonusesCycle = firstRow.SitePayoutBonusesCycle;
          this.SitePayoutBonus = firstRow.SitePayoutBonus;
          this.SiteGratuity = firstRow.SiteGratuity;
          this.SiteUniforms = firstRow.SiteUniforms;
          this.SiteIsUniformsDeposit = firstRow.SiteIsUniformsDeposit;
          this.SiteMinimumWageIndustry = firstRow.SiteMinimumWageIndustry;
          this.SiteMinimumWageZone = firstRow.SiteMinimumWageZone;
          this.SiteMinimumWageStructure = firstRow.SiteMinimumWageStructure;
          this.BillToOption = firstRow.SiteBillTo == '' || firstRow == null ? false : true;
          this.SiteBillTo = firstRow.SiteBillTo;
          this.SiteShipTo = firstRow.SiteShipTo;
          this.SiteAutoMail = firstRow.SiteAutoMail;
          this.SitePlaceOfSupplyApplicable = firstRow.SitePlaceOfSupplyApplicable;
          this.SiteDefaultNarration = firstRow.SiteDefaultNarration;
          this.SiteSubGroupMasterID = firstRow.SiteSubGroupMasterID;
          this.loadbankdetail();
          this.loadgroupdata();
          // if (firstRow.SiteType == 'New Site') {
          //   this.SiteTypeValue = 'New'
          //   this.SiteType = 'New Site'
          // }
          // else if (firstRow.SiteType == 'Lateral Site') {
          //   this.SiteTypeValue = 'Lateral'
          //   this.SiteType = 'Lateral Site'
          // }
          // else {
          //   this.SiteTypeValue = ''
          //   this.SiteType = ''
          // }
        }
        if (this.SData1.length > 0) {
          const firstRow = this.SData1[0];
          this.AreaSqFt = firstRow.AreaSqFt;
          this.BillingCalcDate = this.common.ToUpperCase(firstRow.BillingCalcType);
          if (firstRow.BillingCalcType == 'M') {
            //this.bilCalcDate = 'bilMonth'
            //this.BillingCalcDate = 'M'
            this.BillingFrom = 1;
            this.BillingTo = 0;
          }
          // else if (firstRow.BillingCalcType == 'D') {
          //   // this.bilCalcDate = 'bilDate'
          //   this.BillingCalcDate = 'D'
          // }
          // else {
          //   this.BillingCalcDate = ''
          // }
          this.MachineryChgVal = firstRow.MachineryChgVal;
          if (firstRow.MachineryChgType == 'Fixed Value') {
            this.machinerycharge = 'fix'
            this.MachineryChgType = 'Fixed Value'
          }
          else if (firstRow.MachineryChgType == 'Percentage') {
            this.machinerycharge = 'prcnt'
            this.MachineryChgType = 'Percentage'
          }
          this.MaterialChgVal = firstRow.MaterialChgVal;
          if (firstRow.MaterialChgType == 'Fixed Value') {
            this.MatChargvalue = 'FV'
            this.MaterialChgType = 'Fixed Value'
          }
          else if (firstRow.MaterialChgType == 'Rate / Sq. Ft.') {
            this.MatChargvalue = 'Rsq'
            this.MaterialChgType = 'Rate / Sq. Ft.'
          }
          else if (firstRow.MaterialChgType == 'Percentage') {
            this.MatChargvalue = 'Per'
            this.MaterialChgType = 'Percentage'
          }
          else if (firstRow.MaterialChgType == 'At Actual') {
            this.MatChargvalue = 'Atc'
            this.MaterialChgType = 'At Actual'
          }
          this.SalaryCalcDate = this.common.ToUpperCase(firstRow.SalaryCalcType)
          if (firstRow.SalaryCalcType == 'M') {
            // this.salcalcDate = 'salMonth'
            // this.SalaryCalcDate = 'M'
            this.SalaryFrom = 1;
            this.SalaryTo = 0;
          }
          // else if (firstRow.SalaryCalcType == 'D') {
          //   this.salcalcDate = 'salDate'
          //   this.SalaryCalcDate = 'D'
          // }
          // else {
          //   this.salcalcDate = ''
          // }
          this.SalaryFrom = firstRow.SalaryFrom;
          this.SalaryTo = firstRow.SalaryTo;
          this.BillingFrom = firstRow.BillingFrom;
          this.BillingTo = firstRow.BillingTo;
        }
        if (this.SData2.length > 0) {
          const firstRow = this.SData2[0];
          this.latitude = firstRow.Latitude;
          this.longitude = firstRow.Longitude;
          this.Accuracy = firstRow.Accuracy;
          this.Altitude = firstRow.Altitude;
          this.Heading = firstRow.Heading;
          this.Radius = firstRow.Radius;
          this.IsMocked = firstRow.IsMocked ? 1 : 0;
          this.IsAltitudeApplicable = firstRow.IsAltitudeApplicable;
          this.AltitudeRadius = firstRow.AltitudeRadius;
        }
        if (this.SData3.length > 0) {
          this.ManPowerTable = [];
          this.SData3.forEach(item => {
            let salcal;
            let bilcal;
            if (item.SalaryCalcOn == 'M') {
              salcal = 'Total Month Days'
            } else if (item.SalaryCalcOn == 'W') {
              salcal = 'Total Working Days'
            } else if (item.SalaryCalcOn == 'P') {
              salcal = 'Per Day'
            } else if (item.SalaryCalcOn == 'F') {
              salcal = 'Fix Days'
            } else if (item.SalaryCalcOn == 'S') {
              salcal = 'Month Days'
            }
            if (item.BillingCalcOn == 'M') {
              bilcal = 'Total Month Days'
            } else if (item.BillingCalcOn == 'W') {
              bilcal = 'Total Working Days'
            } else if (item.BillingCalcOn == 'P') {
              bilcal = 'Per Day'
            } else if (item.BillingCalcOn == 'F') {
              bilcal = 'Fix Days'
            } else if (item.BillingCalcOn == 'S') {
              bilcal = 'Month Days'
            }
            const matchingRows = this.SData4.filter(row =>
              row.DesignationId === item.DesignationId && row.DutyId === item.DutyID
            );
            const tableData = matchingRows.length > 0
              ? matchingRows.map(matchingRow => ({
                NoOfEmp: matchingRow.ShiftWiseNoOfPerson,
                ShiftId: matchingRow.ShiftId,
                ShiftTitle: matchingRow.ShiftTitle,
              }))
              : [];
            this.ManPowerTable.push({
              designationid: item.DesignationId,
              designation: item.DesignationName,
              dutyid: item.DutyID,
              duty: item.DutyName,
              NoOfEmp: item.NoOfPerson,
              SalCalc: salcal,
              saldaysValue: item.SalaryCalcDays,
              billcalc: bilcal,
              billDayvalue: item.BillingCalcDays,
              prodDesp: item.ProductDescription,
              table: tableData,
            });
          });
        }

        this.SelectDate('RegistrationDate', null, null);
        this.ESS_SiteManpowerSummary('S');
        this.isDisabled = false
      },
      error => {
        this.isDisabled = false
        console.error('Error:', error);
      }
    );
  }

  ESS_SiteManpowerSummary(Type: String) {
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerSummary({ SelectType: Type, RegionId: this.RegionId.toString(), BranchId: this.BranchId.toString(), ZoneId: this.ZoneId.toString(), ClientId: '', SiteId: this.Sitedatafrmview.SiteMasterId.toString(), SupervisorId: this.SiteOwnerId.toString(), AsOnDate: this.dateFormate.format(this.Date) }).subscribe({
      next: (response) => {
        if (Type == 'S') {
          this.AllocationData = Object.values(response.Table)
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'StateId': (Combotype == 'District') ? this.Stateid : 0,
      'DistrictId': (Combotype == 'Taluka') ? this.DistrictId : 0
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'District') {
          this.District = response.ComboLoad;
          this.isDisabled = false;
        } else if (Combotype == 'Taluka') {
          this.Taluka = response.ComboLoad;
          this.isDisabled = false;
        } else if (Combotype == 'SiteTypeMaster') {
          this.SiteType = response.ComboLoad;
          this.isDisabled = false;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  onSelectChange(type: string) {
    if (type === 'Designation') {
      const selected = this.DesignationLoad.find(designation => designation.DesignationMasterID === this.DesignationId);
      this.Designation = selected ? selected.DesignationName : null;
    }
    else if (type === 'Duty') {
      const selected = this.DutyLoad.find(duty => duty.DutyMasterID === this.DutyId);
      this.Duty = selected ? selected.DutyName : null;
    }
    else if (type === 'Customergroup') {
      this.locationservice.BillCustLoad({ SelectType: 1, ClientGroupMasterId: this.CustGrpId }).subscribe({
        next: (data) => {

          if (data.Table.length > 0) {
            this.BillingCustomer = data.Table;
            this.BillCustId = null;
            this.isDisabled = false
          }
          else {
            this.BillingCustomer = [];
            this.BillCustId = null;
            this.isDisabled = false;
          }
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false
          console.error('Error:', error);
        },
      });
    }
    else if (type == 'BillTypeValue') {
      if (this.BillTypeValue == 'FB') {
        this.BillType = 'Fixed Billing'
      }
      else if (this.BillTypeValue == 'MB') {
        this.BillType = 'Muster Billing'
      }
      else if (this.BillTypeValue == 'BO') {
        this.BillType = 'BillOnSalaryCTC'
      }
    }
    else if (type == 'MaterialCharge') {
      if (this.MatChargvalue == 'FV') {
        this.MaterialChgType = 'Fixed Value'
      }
      else if (this.MatChargvalue == 'Rsq') {
        this.MaterialChgType = 'Rate / Sq. Ft.'
      }
      else if (this.MatChargvalue == 'Per') {
        this.MaterialChgType = 'Percentage'
      }
      else if (this.MatChargvalue == 'Atc') {
        this.MaterialChgType = 'At Actual'
      }
    }
    else if (type == 'MachineryCharge') {
      if (this.machinerycharge == 'fix') {
        this.MachineryChgType = 'Fixed Value'
      }
      else if (this.machinerycharge == 'prcnt') {
        this.MachineryChgType = 'Percentage'
      }
    }
    else if (type == 'State') {
      this.DistrictId = null;
      this.TalukaId = null;
      this.District = [];
      this.Taluka = [];
    }
    else if (type == 'District') {
      this.TalukaId = null;
      this.Taluka = [];
    }
    else if (type == 'Region' && this.common.CompanyParameterValue.CCCode) {
      this.BranchMaster = [];
      this.BranchId = null;
    }
    else if (type == 'SalaryCalculation') {
      if (this.SalaryCalcDate == 'D') {
        this.SalaryCalcDate = 'D'
        this.SalaryFrom = 2;
        this.SalaryTo = 1;
      }
      else if (this.SalaryCalcDate == 'M') {
        this.SalaryCalcDate = 'M'
        this.SalaryFrom = 1;
        this.SalaryTo = 0;
      }
    }
    else if (type == 'BillingCalculation') {
      if (this.BillingCalcDate == 'D') {
        this.BillingCalcDate = 'D'
        this.BillingFrom = 2;
        this.BillingTo = 1;
      }
      else if (this.BillingCalcDate == 'M') {
        this.BillingCalcDate = 'M'
        this.BillingFrom = 1;
        this.BillingTo = 0;
      }
    }
    else if (type == 'Salary') {
      if (this.SalaryFrom < 2 || this.SalaryFrom > 28) {
        this.toast.show({ message: 'Please Enter a Valid Date in Salary Calculation!', type: toastTypeEnum.warning });
        this.SalaryTo = 0;
      }
      else {
        this.SalaryTo = this.SalaryFrom - 1;
      }
    }
    else if (type == 'Billing') {
      if (this.BillingFrom < 2 || this.BillingFrom > 28) {
        this.toast.show({ message: 'Please Enter a Valid Date in Billing Calculation!', type: toastTypeEnum.warning });
        this.BillingTo = 0;
      }
      else {
        this.BillingTo = this.BillingFrom - 1;
      }
    }

    // else if (type == 'SiteType') {
    //   if (this.SiteTypeValue == 'New') {
    //     this.SiteType = 'New Site'
    //   }
    //   else if (this.SiteTypeValue == 'Lateral') {
    //     this.SiteType = 'Lateral Site'
    //   }
    // }
    else if (type == 'Branch') {
      this.Detail.BranchId = this.BranchId;
      this.isDisabled = true;
      this.locationservice.SiteComboLoad(this.Detail).subscribe({
        next: (data) => {
          this.SiteOwner = data.siteowner;
          this.ZoneMaster = data.ZoneMaster;
          this.SiteOwnerId = null
          this.ZoneId = null
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false
          console.error('Error:', error);
        },
      });
    }
  }
  filterInput(event: any) {
    const value = event.target.value;
    event.target.value = value.replace(/[^0-9]/g, '');
  }
  close() {
    this.router.navigate(['master/location']);
  }
  goToNextTab(type: string) {
    const currentActiveId = this.nav.activeId;
    if (type === 'Tab1') {
      if ((this.IndustryId == "" || this.IndustryId == null) && this.common.CompanyParameterValue.CCCode) {
        this.toast.show({ message: 'Please Select Industry Segment.', type: toastTypeEnum.warning });
        return
      }
      else if ((this.ServiceId == "" || this.ServiceId == null) && this.common.CompanyParameterValue.CCCode) {
        this.toast.show({ message: 'Please Select Service Type.', type: toastTypeEnum.warning });
        return
      }
      else if ((this.RegionId == "" || this.RegionId == null) && this.common.CompanyParameterValue.CCCode) {
        this.toast.show({ message: 'Please Select Region.', type: toastTypeEnum.warning });
        return
      }
      else if (this.BranchId == "" || this.BranchId == null) {
        this.toast.show({ message: 'Please Select Branch.', type: toastTypeEnum.warning });
        return
      }

      else if (this.common.CompanyParameterValue.IsESSSiteMasterChannelCode && (this.SiteChannelId == null || this.SiteChannelId == '' || this.SiteChannelId <= 0)) {
        this.toast.show({ message: 'Please Select Channel.', type: toastTypeEnum.warning });
        return
      }

      else if (this.common.CompanyParameterValue.IsESSSiteMasterOracleCode && (this.SiteOracleCode == null || this.SiteOracleCode == '')) {
        this.toast.show({ message: 'Please Enter Old ERP Code.', type: toastTypeEnum.warning });
        return
      }

      else if (this.CustGrpId == "" || this.CustGrpId == null) {
        this.toast.show({ message: 'Please Select Customer Group.', type: toastTypeEnum.warning });
        return
      }
      else if (this.SiteName.trim() === '' || this.SiteName === null) {
        this.toast.show({ message: 'Please Enter Site Name.', type: toastTypeEnum.warning });
        return
      }
      else if (this.FinBranchid == "" || this.FinBranchid == null) {
        this.toast.show({ message: 'Please Select Financial Branch.', type: toastTypeEnum.warning });
        return
      }
      if (this.GroupId == "" || this.GroupId == null) {
        this.toast.show({ message: 'Please Select Group name.', type: toastTypeEnum.warning });
        return
      }
      else if (this.Address1.trim() == "" || this.Address1 == null) {
        this.toast.show({ message: 'Please Enter Address Line 1.', type: toastTypeEnum.warning });
        return
      }
      else if (this.TalukaId == "" || this.TalukaId == null) {
        this.toast.show({ message: 'Please Select Taluka.', type: toastTypeEnum.warning });
        return
      }
      else if (this.ContactPersonName.trim() == "" || this.ContactPersonName == null) {
        this.toast.show({ message: 'Please Enter Contact Person Name.', type: toastTypeEnum.warning });
        return
      }
      else if (this.ContactPersonEmail.trim() == "" || this.ContactPersonEmail == null) {
        this.toast.show({ message: 'Please Enter Contact Person Email.', type: toastTypeEnum.warning });
        return
      }
      else if (this.SalaryCalcDate === '' || this.SalaryCalcDate === null) {
        this.toast.show({ message: 'Please select Salary Calculation.', type: toastTypeEnum.warning });
        return
      }
      else if (this.BillingCalcDate === '' || this.BillingCalcDate === null) {
        this.toast.show({ message: 'Please select Billing Calculation.', type: toastTypeEnum.warning });
        return
      }
      else if (this.BillDutyDivisionBy == null || this.BillDutyDivisionBy <= 0) {
        console.log(this.BillDutyDivisionBy);
        console.log(typeof (this.BillDutyDivisionBy));
        this.toast.show({ message: 'Please Enter Bill Duty Division By.', type: toastTypeEnum.warning });
        return
      }
      if (this.SiteOwnerId == "" || this.SiteOwnerId == null) {
        this.toast.show({ message: 'Please Select SiteOwner.', type: toastTypeEnum.warning });
        return
      }
    }
    else if (type === 'Tab3') {
      if (this.SiteTypeValue === '' || this.SiteTypeValue === null) {
        this.toast.show({ message: 'Please select New/Lateral Site in Additional Details1.', type: toastTypeEnum.warning });
        return
      }
      if (!this.siteactive) {
        this.toast.show({ message: 'Please select Site Activation Date!', type: toastTypeEnum.warning });
        return
      }
      else if (!this.sitend) {
        this.toast.show({ message: 'Please select Site End Date!', type: toastTypeEnum.warning });
        return
      }
      // this.siteactiveObj = this.dateFormate.format(this.siteactive);
      // this.sitendObj = this.dateFormate.format(this.sitend);
      // const fromDate = new Date(this.siteactiveObj);
      // const toDate = new Date(this.sitendObj);
      // if (toDate <= fromDate) {
      //   this.toast.show({ message: 'Site End Date must be greater than Site Start Date!', type: toastTypeEnum.warning });
      //   return
      // }
    }
    else if (type === 'Tab4') {

      if ((this.AttendanceDateValue !== null && this.AttendanceDateValue !== '') && (Number(this.AttendanceDateValue) < 1 || Number(this.AttendanceDateValue) > 31)) {
        this.toast.show({ message: 'Attendance Date should be between 1 and 31!', type: toastTypeEnum.warning });
        return;
      }

      if ((this.SalaryDateValue !== null && this.SalaryDateValue !== '') && (Number(this.SalaryDateValue) < 1 || Number(this.SalaryDateValue) > 31)) {
        this.toast.show({ message: 'Salary Date should be between 1 and 31!', type: toastTypeEnum.warning });
        return;
      }

      if ((this.SalaryPaymentDateValue !== null && this.SalaryPaymentDateValue !== '') && (Number(this.SalaryPaymentDateValue) < 1 || Number(this.SalaryPaymentDateValue) > 31)) {
        this.toast.show({ message: 'Salary Payment Date should be between 1 and 31!', type: toastTypeEnum.warning });
        return;
      }

      if ((this.BillingDateValue !== null && this.BillingDateValue !== '') && (Number(this.BillingDateValue) < 1 || Number(this.BillingDateValue) > 31)) {
        this.toast.show({ message: 'Billing Date should be between 1 and 31!', type: toastTypeEnum.warning });
        return;
      }

      if (this.IsInternalPOCApplicable) {
        if (this.InternalPOCName.trim() == '') {
          this.toast.show({ message: 'Please enter Internal POC Name!', type: toastTypeEnum.warning });
          return
        }

        if (this.InternalPOCMobileNo == '') {
          this.toast.show({ message: 'Please enter Internal POC Mobile!', type: toastTypeEnum.warning });
          return
        }

        if (!this.ValidateEmail(this.InternalPOCMailId)) {
          this.toast.show({ message: 'Enter a valid Internal POC mail id!', type: toastTypeEnum.warning });
          return
        }
      }

      if (this.IsClientPOCApplicable) {

        if (this.ClientPOCName.trim() == '') {
          this.toast.show({ message: 'Please enter Client POC Name!', type: toastTypeEnum.warning });
          return
        }

        if (this.ClientPOCMobileNo == '') {
          this.toast.show({ message: 'Please enter Client Poc Number !', type: toastTypeEnum.warning });
          return
        }

        if (!this.ValidateEmail(this.ClientPOCMailId)) {
          this.toast.show({ message: 'Enter a valid Client POC mail id!', type: toastTypeEnum.warning });
          return
        }
      }
    }
    if (currentActiveId < 5) {
      this.nav.select(currentActiveId + 1);
    }
  }
  ComboLoad2(Combotype: String) {
    this.isDisabled = true;
    if (true || (Combotype == 'Branch')) {
      this.locationservice.ComboLoad({
        'SelectType': Combotype,
        'RegionId': this.common.CompanyParameterValue.CCCode ? this.RegionId : '', //this.Sitedatafrmview.EditSData ? '' : this.RegionId
        'UserId': this.User.UserId
      }).subscribe({
        next: (response: { Table: any; }) => {
          if (Combotype == 'Branch') {
            this.BranchMaster = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: () => {
          this.isDisabled = false;
        },
      });
    } else {
      this.isDisabled = false;
    }
  }
  openGoogleMaps() {
    if (this.latitude && this.longitude) {
      const mapsUrl = `https://www.google.com/maps?q=${this.latitude},${this.longitude}`;
      window.open(mapsUrl, '_blank');
    }
    else {
      this.toast.show({ message: 'Please Provide Latitude and Longitude!', type: toastTypeEnum.warning });
    }
  }
  onSelectionChange() {
    if (this.SalaryCalcOn == 'F') {
      this.SalmonthDayvalue = 0;
    }
    else if (this.SalaryCalcOn == 'S') {
      this.salFixedDaysValue = 0;
    }
    if (this.BillCalOn == 'F') {
      this.BillmonthValue = 0
    }
    else if (this.BillCalOn == 'S') {
      this.BllFixedDaysValue = 0
    }
  }
  MapShift() {
    if (this.DesignationId == '' || this.DesignationId == null) {
      this.toast.show({ message: 'Please select Designation', type: toastTypeEnum.warning });
      return;
    }
    if (this.DutyId == '' || this.DutyId == null) {
      this.toast.show({ message: 'Please select Duty', type: toastTypeEnum.warning });
      return;
    }
    if (!this.editMode) {
      const existingCombination = this.ManPowerTable.findIndex(
        (man) => man.designationid === this.DesignationId && man.dutyid === this.DutyId
      );
      if (existingCombination !== -1) {
        this.toast.show({ message: 'Designation And Duty Already Exists!', type: toastTypeEnum.warning });
        return;
      }
    }
    if (this.noOfEmpValue > 0) {
      const modalOptions: NgbModalOptions = {
        centered: true,
        backdrop: 'static',
        size: 'lg'
      };
      const modalRef = this.modalService.open(MapShiftComponent, modalOptions);
      modalRef.componentInstance.ShiftTable = this.Shift
      modalRef.componentInstance.currentNoOfEmpinLoc = this.noOfEmpValue
      modalRef.componentInstance.editMode = this.editMode
      modalRef.componentInstance.ViewMode = false;
      modalRef.componentInstance.AddShiftonly = this.Sitedatafrmview.EditSData
      modalRef.result.then((result) => {
        if (result) {
          this.Shift = result
        }
      }).catch((reason) => {
        console.error('Modal dismissed:', reason);
      });
    }
    else {
      this.toast.show({ message: ' No Of Employee Should be greater than 0', type: toastTypeEnum.warning });
    }
  }
  add() {
    this.isDisabled = true
    if (this.DesignationId == '' || this.DesignationId == null) {
      this.toast.show({ message: 'Please select Designation', type: toastTypeEnum.warning });
      this.isDisabled = false
      return;
    }
    if (this.DutyId == '' || this.DutyId == null) {
      this.toast.show({ message: 'Please select Duty', type: toastTypeEnum.warning });
      this.isDisabled = false
      return;
    }
    const existingCombination = this.ManPowerTable.findIndex(
      (man) => man.designationid === this.DesignationId && man.dutyid === this.DutyId
    );
    if (!this.editMode && existingCombination !== -1) {
      this.toast.show({ message: 'Designation And Duty Already Exists!', type: toastTypeEnum.warning });
      this.isDisabled = false
      return;
    }
    if (this.noOfEmpValue > 0) {
      const totalNoOfEmp = this.Shift.reduce((total, row) => total + row.NoOfEmp, 0);
      var designationid = this.DesignationId;
      var Designation = this.Designation;
      var dutyid = this.DutyId;
      var Duty = this.Duty;
      var NoOfEmp = this.noOfEmpValue;
      var salCalc = '';
      var salDaysValue = 0;
      var BillCalc = '';
      var BillDayvalue = 0;
      var ProdDesp = this.ProductDesp;
      var TableShift = this.Shift;
      if (this.SalaryCalcOn == 'M') {
        salCalc = 'Total Month Days';
      }
      else if (this.SalaryCalcOn == 'W') {
        salCalc = 'Total Working Days'
      }
      else if (this.SalaryCalcOn == 'P') {
        salCalc = 'Per Day'
      }
      else if (this.SalaryCalcOn == 'F') {
        salCalc = 'Fix Days'
        if (this.salFixedDaysValue != 0) {
          salDaysValue = this.salFixedDaysValue;
          this.SalaryCalcOn = ''
        }
        else {
          this.toast.show({ message: 'Please Fill the Salary Calculation Fix Days Value', type: toastTypeEnum.warning });
          this.isDisabled = false
          return;
        }
      }
      else if (this.SalaryCalcOn == 'S') {
        salCalc = 'Month Days'
        if (this.SalmonthDayvalue != 0) {
          salDaysValue = this.SalmonthDayvalue;
          this.salFixedDaysValue = 0
        }
        else {
          this.toast.show({ message: 'Please Fill the Salary Calculation Month Days Value', type: toastTypeEnum.warning });
          this.isDisabled = false
          return
        }
      }

      if (this.BillCalOn == 'M') {
        BillCalc = 'Total Month Days';
      }
      else if (this.BillCalOn == 'W') {
        BillCalc = 'Total Working Days'
      }
      else if (this.BillCalOn == 'P') {
        BillCalc = 'Per Day'
      }
      // else if (this.BillCalOn == 'F') {
      //   BillCalc = 'Fix Days'
      //   if (this.BllFixedDaysValue != 0) {
      //     BillDayvalue = this.BllFixedDaysValue
      //   }
      //   BillCalc = 'Month Days'
      //   if (this.BllFixedDaysValue != 0) {
      //     BillDayvalue = this.BllFixedDaysValue;
      //     this.BillmonthValue = 0
      //   }
      //   else {
      //     this.toast.show({ message: 'Please Fill the Billing Calculation Fix Days Value', type: toastTypeEnum.warning });
      //     this.isDisabled = false
      //     return
      //   }
      // }
      // else if (this.BillCalOn == 'S') {
      //   BillCalc = 'Month Days'
      //   if (this.BillmonthValue != 0) {
      //     BillDayvalue = this.BillmonthValue
      //   }
      //   else {
      //     this.toast.show({ message: 'Please Fill the Billing Calculation Month Days Value', type: toastTypeEnum.warning });
      //     this.isDisabled = false
      //     return
      //   }
      // }
      else if (this.BillCalOn == 'F') {
        BillCalc = 'Fix Days'
        if (this.BllFixedDaysValue != 0) {
          BillDayvalue = this.BllFixedDaysValue
        }
        else {
          this.toast.show({ message: 'Please Fill the Billing Calculation Fix Days Value', type: toastTypeEnum.warning });
          this.isDisabled = false
          return
        }
      }
      else if (this.BillCalOn == 'S') {
        BillCalc = 'Month Days'
        if (this.BillmonthValue != 0) {
          BillDayvalue = this.BillmonthValue
        }
        else {
          this.toast.show({ message: 'Please Fill the Billing Calculation Month Days Value', type: toastTypeEnum.warning });
          this.isDisabled = false
          return
        }
      }
      if (!this.editMode && existingCombination === -1) {
        if (totalNoOfEmp != this.noOfEmpValue) {
          this.toast.show({ message: 'Shift is not Assigned to the Employees', type: toastTypeEnum.warning });
          this.isDisabled = false
          return;
        }
      }
      if (this.editMode) {
        if (totalNoOfEmp != this.noOfEmpValue) {
          this.toast.show({ message: 'Shift is not Assigned to the Employees', type: toastTypeEnum.warning });
          this.isDisabled = false
          return;
        }
      }
      var ManPower = {
        designationid: designationid,
        designation: Designation,
        dutyid: dutyid,
        duty: Duty,
        NoOfEmp: NoOfEmp,
        SalCalc: salCalc,
        saldaysValue: salDaysValue,
        billcalc: BillCalc,
        billDayvalue: BillDayvalue,
        prodDesp: ProdDesp,
        table: TableShift
      };
      if (this.editMode) {
        this.ManPowerTable[this.Index] = ManPower;
      } else {
        this.ManPowerTable.push(ManPower);
      }
      console.log('table', this.ManPowerTable);
      this.clearFeild();
    }
    else {
      this.toast.show({ message: 'Cannot Add 0 Employee', type: toastTypeEnum.warning });
      this.isDisabled = false
      return;
    }
    this.isDisabled = false
    this.editMode = false;
  }
  clearFeild() {
    this.Shift = [];
    this.noOfEmpValue = 0;
    this.ProductDesp = '';
    this.DesignationId = null;
    this.DutyId = null;
    this.SalaryCalcOn = 'M';
    this.BillCalOn = 'M';
    this.salFixedDaysValue = 0;
    this.SalmonthDayvalue = 0;
    this.SalmonthDayvalue = 0;
    this.BillmonthValue = 0;
    this.BllFixedDaysValue = 0;
  }
  onKeyPress(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    const inputValue = event.target.value;
    if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
      const hasDecimal = inputValue.includes('.');
      if (!hasDecimal || (charCode >= 48 && charCode <= 57)) {
        const newValue = parseFloat(inputValue + String.fromCharCode(charCode));
        const decimalPart = (newValue.toString().split('.')[1] || '').length;
        if (decimalPart <= 2 && newValue >= 1 && newValue <= 31) {
          return;
        }
      }
    }
    event.preventDefault();
  }
  deleteRow(index: number): void {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Delete?'

    modalRef.result.then((result: any) => {
      if (result) {
        this.ManPowerTable.splice(index, 1);
      }
    }).catch(() => {

    });
  }
  onEditClick(element: any, index: number): void {
    this.isDisabled = true
    this.Index = index;
    this.editMode = true;
    this.DesignationId = element.designationid;
    this.Designation = element.designation;
    this.DutyId = element.dutyid;
    this.Duty = element.duty;
    this.noOfEmpValue = element.NoOfEmp;
    this.ProductDesp = element.prodDesp;
    this.Shift = element.table;

    if (element.SalCalc == 'Total Month Days') {
      this.SalaryCalcOn = 'M';
    }
    else if (element.SalCalc == 'Total Working Days') {
      this.SalaryCalcOn = 'W';
    }
    else if (element.SalCalc == 'Per Day') {
      this.SalaryCalcOn = 'P';
    }
    else if (element.SalCalc == 'Fix Days') {
      this.SalaryCalcOn = 'F';
      this.salFixedDaysValue = element.saldaysValue;
      this.SalmonthDayvalue = 0;
    }
    else if (element.SalCalc == 'Month Days') {
      this.SalaryCalcOn = 'S';
      this.SalmonthDayvalue = element.saldaysValue;
      this.salFixedDaysValue = 0;
    }

    if (element.billcalc == 'Total Month Days') {
      this.BillCalOn = 'M';
    }
    else if (element.billcalc == 'Total Working Days') {
      this.BillCalOn = 'W';
    }
    else if (element.billcalc == 'Per Day') {
      this.BillCalOn = 'P';
    }
    else if (element.billcalc == 'Fix Days') {
      this.BillCalOn = 'F';
      this.BllFixedDaysValue = element.billDayvalue;
      this.BillmonthValue = 0;
    }
    else if (element.billcalc == 'Month Days') {
      this.BillCalOn = 'S';
      this.BillmonthValue = element.billDayvalue;
      this.BllFixedDaysValue = 0;
    }
    this.isDisabled = false
  }
  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit || this.common.PageRight.IsAdd) {
        if (result) {
          if ((this.sitend == null || this.sitend == '') || (moment(this.dateFormate.format(this.sitend), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.siteactive), 'DD MMM YYYY')))) {
            this.SaveandUpdate();
          } else {
            this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
            this.sitend = null;
          }
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }
  SaveandUpdate() {
    this.WorkOrderDateObj = this.dateFormate.format(this.WorkOrderDate);
    this.ValidTillObj = this.dateFormate.format(this.ValidTill);
    this.ContractStartDateObj = this.dateFormate.format(this.ContractStartDate);
    this.siteactiveObj = this.dateFormate.format(this.siteactive);
    this.sitendObj = this.dateFormate.format(this.sitend);
    if ((this.IndustryId == "" || this.IndustryId == null) && this.common.CompanyParameterValue.CCCode) {
      this.toast.show({ message: 'Please Select Industry Segment in Site.', type: toastTypeEnum.warning });
      return
    }
    if ((this.ServiceId == "" || this.ServiceId == null) && this.common.CompanyParameterValue.CCCode) {
      this.toast.show({ message: 'Please Select Service Name in Site.', type: toastTypeEnum.warning });
      return
    }

    if ((this.RegionId == "" || this.RegionId == null) && this.common.CompanyParameterValue.CCCode) {
      this.toast.show({ message: 'Please Select Region in Site.', type: toastTypeEnum.warning });
      return
    }
    if (this.BranchId == "" || this.BranchId == null) {
      this.toast.show({ message: 'Please Select Branch Name in Site.', type: toastTypeEnum.warning });
      return
    }

    else if (this.common.CompanyParameterValue.IsESSSiteMasterChannelCode && (this.SiteChannelId == null || this.SiteChannelId == '' || this.SiteChannelId <= 0)) {
      this.toast.show({ message: 'Please Select Channel.', type: toastTypeEnum.warning });
      return
    }

    else if (this.common.CompanyParameterValue.IsESSSiteMasterOracleCode && (this.SiteOracleCode == null || this.SiteOracleCode == '')) {
      this.toast.show({ message: 'Please Enter Old ERP Code.', type: toastTypeEnum.warning });
      return
    }

    if (this.CustGrpId == "" || this.CustGrpId == null) {
      this.toast.show({ message: 'Please Select Customer Group in Site.', type: toastTypeEnum.warning });
      return
    }
    if (this.SiteName.trim() == "" || this.SiteName === null) {
      this.toast.show({ message: 'Please Enter Site Name.', type: toastTypeEnum.warning });
      return
    }
    if (this.FinBranchid == "" || this.FinBranchid == null) {
      this.toast.show({ message: 'Please Select Financial Branch in Site.', type: toastTypeEnum.warning });
      return
    }
    if (this.GroupId == "" || this.GroupId == null) {
      this.toast.show({ message: 'Please Select Group name in Site.', type: toastTypeEnum.warning });
      return
    }
    if (this.Address1.trim() == "" || this.Address1 == null) {
      this.toast.show({ message: 'Please Enter Address Line 1.', type: toastTypeEnum.warning });
      return
    }
    if (this.TalukaId == "" || this.TalukaId == null) {
      this.toast.show({ message: 'Please Select Taluka in Site.', type: toastTypeEnum.warning });
      return
    }
    else if (this.ContactPersonName.trim() == "" || this.ContactPersonName == null) {
      this.toast.show({ message: 'Please Enter Contact Person Name.', type: toastTypeEnum.warning });
      return
    }
    else if (this.ContactPersonEmail.trim() == "" || this.ContactPersonEmail == null) {
      this.toast.show({ message: 'Please Enter Contact Person Email.', type: toastTypeEnum.warning });
      return
    }
    else if (this.BillDutyDivisionBy == null || this.BillDutyDivisionBy <= 0) {
      this.toast.show({ message: 'Please Enter Bill Duty Division By.', type: toastTypeEnum.warning });
      return
    }
    if (this.SalaryCalcDate === '' || this.SalaryCalcDate === null) {
      this.toast.show({ message: 'Please select Salary Calculation.', type: toastTypeEnum.warning });
      return
    }
    if (this.BillingCalcDate === '' || this.BillingCalcDate === null) {
      this.toast.show({ message: 'Please select Billing Calculation.', type: toastTypeEnum.warning });
      return
    }
    if (this.SalaryCalcDate == 'D') {
      if (this.SalaryFrom < 2 || this.SalaryFrom > 28) {
        this.toast.show({ message: 'Please Enter a Valid Date in Salary Calculation!', type: toastTypeEnum.warning });
        this.SalaryTo = 0;
        return
      }
    }
    if (this.BillingCalcDate == 'D') {
      if (this.BillingFrom < 2 || this.BillingFrom > 28) {
        this.toast.show({ message: 'Please Enter a Valid Date in Billing Calculation!', type: toastTypeEnum.warning });
        this.BillingTo = 0;
        return
      }
    }
    else if (this.WeeklyOffDivisionBy < 6 || this.WeeklyOffDivisionBy > 7) {
      this.toast.show({ message: 'Please Enter valid Weekly Off Division By.', type: toastTypeEnum.warning }); //suggested by rahul sir 
      return
    }
    if (this.SiteTypeValue === '' || this.SiteTypeValue === null) {
      this.toast.show({ message: 'Please select New/Lateral Site in Additional Details1.', type: toastTypeEnum.warning });
      return
    }
    if (!this.siteactive) {
      this.toast.show({ message: 'Please select Site Activation Date!', type: toastTypeEnum.warning });
      return
    }
    if (!this.sitend) {
      this.toast.show({ message: 'Please select Site End Date!', type: toastTypeEnum.warning });
      return
    }

    if (this.IsInternalPOCApplicable) {

      if (this.InternalPOCName.trim() == '') {
        this.toast.show({ message: 'Please enter Internal POC Name!', type: toastTypeEnum.warning });
        return
      }

      if (this.InternalPOCMobileNo == '') {
        this.toast.show({ message: 'Please enter Internal POC Mobile!', type: toastTypeEnum.warning });
        return
      }

      if (!this.ValidateEmail(this.InternalPOCMailId)) {
        this.toast.show({ message: 'Enter a valid Internal POC mail id!', type: toastTypeEnum.warning });
        return
      }
    }

    if (this.IsClientPOCApplicable) {

      if (this.ClientPOCName.trim() == '') {
        this.toast.show({ message: 'Please enter Client POC Name!', type: toastTypeEnum.warning });
        return
      }

      if (this.ClientPOCMobileNo == '') {
        this.toast.show({ message: 'Please enter Client Poc Number !', type: toastTypeEnum.warning });
        return
      }

      if (!this.ValidateEmail(this.ClientPOCMailId)) {
        this.toast.show({ message: 'Enter a valid Client POC mail id!', type: toastTypeEnum.warning });
        return
      }
    }

    if ((this.AttendanceDateValue !== null && this.AttendanceDateValue !== '') && (Number(this.AttendanceDateValue) < 1 || Number(this.AttendanceDateValue) > 31)) {
      this.toast.show({ message: 'Attendance Date should be between 1 and 31 in Additional Detail 2!', type: toastTypeEnum.warning });
      return;
    }

    if ((this.SalaryDateValue !== null && this.SalaryDateValue !== '') && (Number(this.SalaryDateValue) < 1 || Number(this.SalaryDateValue) > 31)) {
      this.toast.show({ message: 'Salary Date should be between 1 and 31 in Additional Detail 2!', type: toastTypeEnum.warning });
      return;
    }

    if ((this.SalaryPaymentDateValue !== null && this.SalaryPaymentDateValue !== '') && (Number(this.SalaryPaymentDateValue) < 1 || Number(this.SalaryPaymentDateValue) > 31)) {
      this.toast.show({ message: 'Salary Payment Date should be between 1 and 31 in Additional Detail 2!', type: toastTypeEnum.warning });
      return;
    }

    if ((this.BillingDateValue !== null && this.BillingDateValue !== '') && (Number(this.BillingDateValue) < 1 || Number(this.BillingDateValue) > 31)) {
      this.toast.show({ message: 'Billing Date should be between 1 and 31 in Additional Detail 2!', type: toastTypeEnum.warning });
      return;
    }

    // const fromDate = new Date(this.siteactiveObj);
    // const toDate = new Date(this.sitendObj);
    // if (toDate <= fromDate) {
    //   this.toast.show({ message: 'Site End Date must be greater than Site Start Date!', type: toastTypeEnum.warning });
    //   return
    // }
    if (this.SiteOwnerId == "" || this.SiteOwnerId == null) {
      this.toast.show({ message: 'Please Select SiteOwner in Site.', type: toastTypeEnum.warning });
      return
    }

    const essSiteManpowerData = this.ManPowerTable.map(manpower => {
      let salaryCalcOnValue;
      let BillingCalcOnValue;
      if (manpower.SalCalc === 'Total Month Days') {
        salaryCalcOnValue = 'M';
      } else if (manpower.SalCalc === 'Total Working Days') {
        salaryCalcOnValue = 'W';
      } else if (manpower.SalCalc === 'Per Day') {
        salaryCalcOnValue = 'P';
      } else if (manpower.SalCalc === 'Fix Days') {
        salaryCalcOnValue = 'F';
      } else if (manpower.SalCalc === 'Month Days') {
        salaryCalcOnValue = 'S';
      }
      if (manpower.billcalc === 'Total Month Days') {
        BillingCalcOnValue = 'M';
      } else if (manpower.billcalc === 'Total Working Days') {
        BillingCalcOnValue = 'W';
      } else if (manpower.billcalc === 'Per Day') {
        BillingCalcOnValue = 'P';
      } else if (manpower.billcalc === 'Fix Days') {
        BillingCalcOnValue = 'F';
      } else if (manpower.billcalc === 'Month Days') {
        BillingCalcOnValue = 'S';
      }
      return {
        DesignationId: manpower.designationid,
        DutyId: manpower.dutyid,
        NoOfPerson: manpower.NoOfEmp,
        SalaryCalcOn: salaryCalcOnValue,
        SalaryCalcDays: manpower.saldaysValue,
        BillingCalcOn: BillingCalcOnValue,
        BillingCalcDays: manpower.billDayvalue,
        ProductDescription: manpower.prodDesp
      };
    });
    const essShiftDetailsData: any[] = [];
    this.ManPowerTable.forEach(row => {
      const commonProperties = {
        DesignationId: row.designationid,
        DutyId: row.dutyid,
      };
      row.table.forEach((tableRow: { ShiftId: any; NoOfEmp: number; }) => {
        const shiftDetails = {
          ...commonProperties,
          ShiftId: tableRow.ShiftId,
          ShiftWiseNoOfPerson: tableRow.NoOfEmp,
        };
        essShiftDetailsData.push(shiftDetails);
      });
    });
    const SiteIndertUpdate = {
      SelectType: this.Sitedatafrmview.EditSData ? 'Update' : 'Insert',
      SiteMasterId: this.Sitedatafrmview.SiteMasterId,
      IndustrySegmentID: this.IndustryId,
      ServiceTypeID: this.ServiceId,
      RegionID: this.RegionId,
      BranchID: this.BranchId,
      ClientGroupId: this.CustGrpId,
      MaxClientId: this.BillCustId,
      SiteCode: this.SiteCode,
      SiteName: this.SiteName,
      FinancialBranchID: this.FinBranchid,
      GroupID: this.GroupId,
      Address1: this.Address1,
      Address2: this.Address2,
      City: this.City,
      PinCode: this.Pincode,
      TelephoneNo: this.Telephone,
      StateID: this.Stateid,
      DistrictID: this.DistrictId,
      TalukaID: this.TalukaId,
      ContactPersonName: this.ContactPersonName,
      ContactPersonEmail: this.ContactPersonEmail,
      ContactPersonNo: this.ContactPersonNo,
      Compliance: this.Compliance,
      BillType: this.BillType,
      BillDutyDivisionBy: this.BillDutyDivisionBy,
      ZoneId: this.ZoneId,
      PFApplicable: this.PfApplicable, //(this.PfApplicable == 1) ? true : false,
      ESICApplicable: this.ESICApplicable, //== 1) ? true : false,
      PTApplicable: this.PTApplicable,// == 1) ? true : false,
      LWFApplicable: this.LWFApplicable,// == 1) ? true : false,
      WeeklyOffDivideBy: this.WeeklyOffDivisionBy,
      PFonBasicDAOT: this.pfonbasicdaot,// == 1) ? true : false,
      AdminChargesApplicable: this.AdminCharge,// == 1) ? true : false,
      OnlineAttendanceFreeze: this.attendence,// == 1) ? true : false,
      Active: this.Isactive,// == 1) ? true : false,
      SalaryCalcType: this.SalaryCalcDate,
      SalaryFrom: this.SalaryFrom,
      SalaryTo: this.SalaryTo,
      BillingCalcType: this.BillingCalcDate,
      BillingFrom: this.BillingFrom,
      BillingTo: this.BillingTo,
      SiteOwnerID: this.SiteOwnerId,
      Latitude: this.latitude,
      Longitude: this.longitude,
      Accuracy: this.Accuracy,
      Altitude: this.IsAltitudeApplicable ? this.Altitude : 0,
      Heading: this.Heading,
      Radius: this.Radius,
      IsMocked: (this.IsMocked == 1) ? true : false,
      WorkOrderNumber: this.WorkOrderNumber,
      ClientSiteCode: this.ClientSiteCode,
      WorkOrderDate: this.WorkOrderDateObj,
      ValidTill: this.ValidTillObj,
      WorkOrderValue: this.WorkOrderValue,
      ContractStartDate: this.ContractStartDateObj,
      ContractValue: this.ContractValue,
      AnnualValue: this.AnnualValue,
      Narration: this.Narration,
      AgreementType: this.AgreementType,
      NoOfAgreement: this.NoOfAgreement,
      ReportType: this.ReportTypeId,
      Tender: this.Tender,
      TenureOfContract: this.TenureofContract,
      MinimumEscalationClause: this.MinimumEscalationClause,
      BillingName: this.BillingName,
      ManpowerCost: this.ManpowerCost,
      ManpowerOption: this.ManPowerValue,
      ManpowerValue: this.ManPowerValueAtactual,
      MachineryCost: this.MachineryCost,
      MachineryOption: this.MachineryOption,
      MachineryValue: this.MachineryValue,
      ConsumableCost: this.ConsumableCost,
      ConsumableOption: this.consumoptvalue,
      ConsumableValue: this.consumablevalue,
      ManagementFees: this.ManagementFees,
      MgmtFeesValue: this.MgmtFeesValue,
      UniformOption: this.uniformvalue,
      SiteType: this.SiteTypeValue,
      OtherChargesOption: this.OtherChargesvalue,
      OtherCharges: this.OtherValue,
      SiteStartDate: this.siteactiveObj,
      SiteEndDate: this.sitendObj,
      RBIIndex: this.RBIIndex,// == 1) ? true : false,
      MinWages: this.MinWages,// == 1) ? true : false,
      PerIncGrowth: this.PerIncGrowth,// == 1) ? true : false,
      GuardBoardIndex: this.GuardBoardIndex,// == 1) ? true : false,
      NewIndustrySegment: this.NewIndustrySegment,
      SubServiceType: this.SubServiceType,
      NewSubLocation1: this.NewSubLocation1,
      NewSubLocation2: this.NewSubLocation2,
      OperationTeamEmailId: this.OperationTeamEmailId,
      CompNatureofWork: this.CompNatureofWork,
      AreaSqFt: this.AreaSqFt,
      MaterialChgType: this.MaterialChgType,
      MaterialChgVal: this.MaterialChgVal,
      MachineryChgType: this.MachineryChgType,
      MachineryChgVal: this.MachineryChgVal,
      ESS_SiteManpower: essSiteManpowerData,
      ESS_ShiftDetails: essShiftDetailsData,
      UserId: this.User.UserId,

      PPUMachineryCost: this.PPUMachineryCost,
      PPUBGCost: this.PPUBGCost,
      PPUBusinessProvisionPercent: this.PPUBusinessProvisionPercent,
      PPUBusinessProvisionValue: this.PPUBusinessProvisionValue,
      CISMarginValue: this.CISMarginValue,
      Sitecount: this.Sitecount,
      ManpowerStrength: this.ManpowerStrength,
      AttendanceDateValue: this.AttendanceDateValue,
      SalaryDateValue: this.SalaryDateValue,
      SalaryPaymentDateValue: this.SalaryPaymentDateValue,
      BillingDateValue: this.BillingDateValue,
      SiteTypeID: this.SiteTypeID,

      IsInternalPOCApplicable: this.IsInternalPOCApplicable,
      InternalPOCName: this.IsInternalPOCApplicable ? this.InternalPOCName : '',
      InternalPOCMobileNo: this.IsInternalPOCApplicable ? this.InternalPOCMobileNo : '',
      InternalPOCMailId: this.IsInternalPOCApplicable ? this.InternalPOCMailId : '',
      IsClientPOCApplicable: this.IsClientPOCApplicable,

      // code
      IsClientAttendanceInformationMail: this.IsClientAttendanceInformationMail,
      ClientPOCName: (this.IsClientPOCApplicable || this.IsClientAttendanceInformationMail)  ? this.ClientPOCName : '',
      ClientPOCMobileNo: (this.IsClientPOCApplicable || this.IsClientAttendanceInformationMail)  ? this.ClientPOCMobileNo : '',
      ClientPOCMailId: (this.IsClientPOCApplicable || this.IsClientAttendanceInformationMail) ? this.ClientPOCMailId : '',
      IsAltitudeApplicable: this.IsAltitudeApplicable,
      AltitudeRadius: this.IsAltitudeApplicable ? this.AltitudeRadius : 0,

      SiteChannelId: this.SiteChannelId,
      SiteOracleCode: this.SiteOracleCode,
      SiteAlternateCode: this.SiteAlternateCode,
      SiteAgreementCopyAttachment: this.SiteAgreementCopyAttachment,
      SiteBankId: this.SiteBankId,
      SiteAttendanceThrough: this.SiteAttendanceThrough,
      SiteLeaveSalarCycle: this.SiteLeaveSalarCycle,
      SiteLeaveSalary: this.SiteLeaveSalary,
      SitePayoutBonusesCycle: this.SitePayoutBonusesCycle,
      SitePayoutBonus: this.SitePayoutBonus,
      SiteGratuity: this.SiteGratuity,
      SiteUniforms: this.SiteUniforms,
      SiteIsUniformsDeposit: this.SiteIsUniformsDeposit,
      SiteMinimumWageIndustry: this.SiteMinimumWageIndustry,
      SiteMinimumWageZone: this.SiteMinimumWageZone,
      SiteMinimumWageStructure: this.SiteMinimumWageStructure,
      SiteBillTo: this.BillToOption ? this.SiteBillTo : '',
      SiteShipTo: this.BillToOption ? this.SiteShipTo : '',
      SiteAutoMail: this.SiteAutoMail,
      SitePlaceOfSupplyApplicable: this.SitePlaceOfSupplyApplicable,
      SiteDefaultNarration: this.SiteDefaultNarration,
      SiteSubGroupMasterID: this.SiteSubGroupMasterID
    }

    this.isDisabled = true
    this.locationservice.SiteInsert(SiteIndertUpdate).subscribe({
      next: async (data) => {
        this.RETURN.ReturnedSiteId = data.ReturnedSiteId;
        this.RETURN.ReturnedSiteCode = data.ReturnedSiteCode;
        this.ErrorCode = data.Error_Code;
        if (data.Error_Code == '01') {
          if (this.User.CompanyCode === 'MSF' || this.User.CompanyCode === 'MFM') {
            if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

            }
            else {
              await this.Transovative(this.RETURN.ReturnedSiteCode, 'SiteCode', 'SiteMaster');

              if (this.Sitedatafrmview.EditSData) {
                await this.Transovative(this.RETURN.ReturnedSiteCode, 'SiteCode', 'activatedeactivatesite');
              }
            }
          }
          this.isDisabled = false
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
      },
      complete: () => {
        if (this.ErrorCode == '01') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Site Manpower Details Saved  Successfully';
          modalRef.result.then((result: any) => {
            if (result) {
              this.close();
            }
          });
          this.isDisabled = false;
        }
      },
      error: (error: any) => {
        this.isDisabled = false;
      },
    });
  }
  ViewShift(element: any) {
    this.Shift = element.table;
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    };
    const modalRef = this.modalService.open(MapShiftComponent, modalOptions);
    modalRef.componentInstance.ShiftTable = this.Shift;
    modalRef.componentInstance.editMode = true;
    modalRef.componentInstance.ViewMode = true;
  }

  PreventKey(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57 || input.value.length >= 7) {
      event.preventDefault();
    }
  }

  PreventKey1(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const charCode = event.which || event.keyCode;
    const currentValue = input.value;
    const isNumber = charCode >= 48 && charCode <= 57;
    const isDecimal = charCode === 46;
    const containsDecimal = currentValue.includes('.');
    if (
      (isNumber) ||
      (isDecimal && !containsDecimal) ||
      currentValue.length < 7
    ) {
    } else {
      event.preventDefault();
    }
  }

  Transovative(id: any, SQL_IDColumnName: string, formname: string) {
    let form = 'SiteMaster'
    const data = {
      SQL_TableName: formname == 'activatedeactivatesite' ? form : formname,
      SQL_IDColumnName: SQL_IDColumnName,
      DefaultSyncAPI: false,
      ZingHRSyncAPI: false,
      ProptorSyncAPI: false,
      UserId: this.User.UserId,
      Id: id
    }
    this.locationservice.SetSyncAPIFlagIn(data).subscribe({
      next: (response) => {

      },
      complete: async () => {
        //await this.GetMaster(id, formname);
        let MasterName = ''
        if (formname === 'SiteMaster') {
          MasterName = 'Site' // commented for transovative changes
          // MasterName = 'SiteNew';
        }
        else if (formname === 'activatedeactivatesite') {
          MasterName = 'activatedeactivatesite'
        }
        await this.locationservice.GetMaster({ MasterName: MasterName, MasterCode: id }).subscribe({
          next: async (response) => {
            if (response.Table.length > 0) {
              //this.SubMasterApi(formname, response.Table[0], id);
              const activatedeactivatesite = {
                siteid: response.Table[0].siteid,
                servicetype: this.User.CompanyCode,
                status: response.Table[0].status,
                OperationType: 'activatedeactivatesite',
                Action: 'activatedeactivatesite'
              }
              
              const siteforAdd = {
                siteid: response.Table[0].location_code,
                sitename: response.Table[0].location_name,
                address: response.Table[0].site_address,
                branch: response.Table[0].branch_code,
                servicetype: response.Table[0].CompanyCode,
                client: response.Table[0].client_group_code,
                clientname: response.Table[0].ClientName,
                clientemail: response.Table[0].ContactPersonEmail,
                deploymentdate: response.Table[0].DeploymentDate,
                siteownercode: response.Table[0].site_owner_code,
                authorizedstrength: response.Table[0].authorizedstrength,
                clientmobile: response.Table[0].clientmobile,
                City: response.Table[0].Taluka,
                state: response.Table[0].state,
                Region: response.Table[0].Region,
                OperationType: 'site',
                Action: 'add'
              }
              const siteforedit = {
                siteid: response.Table[0].location_code,
                sitename: response.Table[0].location_name,
                address: response.Table[0].site_address,
                branch: response.Table[0].branch_code,
                servicetype: response.Table[0].CompanyCode,
                client: response.Table[0].client_group_code,
                clientname: response.Table[0].ClientName,
                clientemail: response.Table[0].ContactPersonEmail,
                deploymentdate: response.Table[0].DeploymentDate,
                siteownercode: response.Table[0].site_owner_code,
                guardingtype: response.Table[0].guardingtype,
                armedguards: response.Table[0].armedguards,
                unarmedguards: response.Table[0].unarmedguards,
                authorizedstrength: response.Table[0].authorizedstrength,
                clientmobile: response.Table[0].clientmobile,
                City: response.Table[0].Taluka,
                state: response.Table[0].state,
                Region: response.Table[0].Region,
                OperationType: 'site',
                Action: 'edit'
              }
              let data = {
              }
              if (formname === 'SiteMaster' && !this.Sitedatafrmview.EditSData) {
                data = siteforAdd;
              }
              else if (formname === 'SiteMaster' && this.Sitedatafrmview.EditSData) {
                data = siteforedit;
              }
              else if (formname === 'activatedeactivatesite') {
                data = activatedeactivatesite;
              }
              await this.locationservice.SubMasterApi(data).subscribe({
                next: async (response) => {
                  this.ResData = response
                  alert(response.DefaultMessage);
                  if (response.ErrorCode === '1024' && this.Sitedatafrmview.EditSData) {
                    const modalRef = this.modalService.open(ConfirmationComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = 'Do you want to add Location in EFSR? Location not found in EFSR'
                    modalRef.result.then(async (result: any) => {
                      if (result) {
                        this.Sitedatafrmview.EditSData = false;
                        await this.Transovative(this.RETURN.ReturnedSiteCode, 'SiteCode', 'SiteMaster');
                      }
                      await this.Transovative(this.RETURN.ReturnedSiteCode, 'SiteCode', 'activatedeactivatesite');
                    }).catch(() => {

                    });
                  }
                },
                complete: async () => {
                  await this.Transovative_SubMasterApi_ConsumptionLogs(formname, id, this.ResData, response.Table[0]);
                  this.isDisabled = false;
                },
                error: (error: any) => {
                  this.isDisabled = false;
                },
              });
            }
          },
          complete: () => {
            this.isDisabled = false;
          },
          error: (error: any) => {
            this.isDisabled = false;
          },
        });
        this.isDisabled = false;
      },
      error: (error: any) => {
        this.isDisabled = false;
      },
    });
  }
  // GetMaster(id: any, name: string) {
  //   let MasterName = ''
  //   if (name === 'SiteMaster') {
  //     MasterName = 'Site'
  //   }
  //   else if (name === 'activatedeactivatesite') {
  //     MasterName = 'activatedeactivatesite'
  //   }
  //   this.locationservice.GetMaster({ MasterName: MasterName, MasterCode: id }).subscribe({
  //     next: async (response) => {
  //       if (response.Table.length > 0) {
  //         await this.SubMasterApi(name, response.Table[0], id);
  //       }
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //     },
  //     error: (error: any) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }
  // async SubMasterApi(name: string, res: any, id: any) {
  //   const activatedeactivatesite = {
  //     siteid: res.siteid,
  //     servicetype: this.User.CompanyCode,
  //     status: res.status,
  //     OperationType: 'activatedeactivatesite',
  //     Action: 'activatedeactivatesite'
  //   }
  //   const siteforAdd = {
  //     siteid: res.location_code,
  //     sitename: res.location_name,
  //     address: res.site_address,
  //     branch: res.branch_code,
  //     servicetype: res.CompanyCode,
  //     client: res.client_group_code,
  //     clientname: res.ClientName,
  //     clientemail: res.ContactPersonEmail,
  //     deploymentdate: res.DeploymentDate,
  //     siteownercode: res.site_owner_code,
  //     authorizedstrength: res.authorizedstrength,
  //     OperationType: 'site',
  //     Action: 'add'
  //   }
  //   const siteforedit = {
  //     siteid: res.location_code,
  //     sitename: res.location_name,
  //     address: res.site_address,
  //     branch: res.branch_code,
  //     servicetype: res.CompanyCode,
  //     client: res.client_group_code,
  //     clientname: res.ClientName,
  //     clientemail: res.ContactPersonEmail,
  //     deploymentdate: res.DeploymentDate,
  //     siteownercode: res.site_owner_code,
  //     guardingtype: res.guardingtype,
  //     armedguards: res.armedguards,
  //     unarmedguards: res.unarmedguards,
  //     authorizedstrength: res.authorizedstrength,
  //     OperationType: 'site',
  //     Action: 'edit'
  //   }
  //   let data = {
  //   }
  //   if (name === 'SiteMaster' && !this.Sitedatafrmview.EditSData) {
  //     data = siteforAdd;
  //   }
  //   else if (name === 'SiteMaster' && this.Sitedatafrmview.EditSData) {
  //     data = siteforedit;
  //   }
  //   else if (name === 'activatedeactivatesite') {
  //     data = activatedeactivatesite;
  //   }
  //   await this.locationservice.SubMasterApi(data).subscribe({
  //     next: async (response) => {
  //       this.ResData = response
  //       alert(response.DefaultMessage);
  //       if (response.ErrorCode === '1024' && this.Sitedatafrmview.EditSData) {
  //         const modalRef = this.modalService.open(ConfirmationComponent, {
  //           size: 'md',
  //           backdrop: 'static',
  //           centered: true,
  //           windowClass: 'confirmation-modal'
  //         });
  //         modalRef.componentInstance.Message = 'Do you want to add Location in EFSR? ,Location not found in EFSR'
  //         modalRef.result.then(async (result: any) => {
  //           if (result) {
  //             this.Sitedatafrmview.EditSData = false;
  //             await this.Transovative(this.RETURN.ReturnedSiteCode, 'SiteCode', 'SiteMaster');
  //           }
  //           await this.Transovative(this.RETURN.ReturnedSiteCode, 'SiteCode', 'activatedeactivatesite');
  //         }).catch(() => {

  //         });
  //       }
  //     },
  //     complete: () => {
  //       this.Transovative_SubMasterApi_ConsumptionLogs(name, id, this.ResData, res);
  //       this.isDisabled = false;
  //     },
  //     error: (error: any) => {
  //       this.isDisabled = false;
  //     },
  //   });

  // }
  Transovative_SubMasterApi_ConsumptionLogs(name: string, id: any, res: any, requestjson: any) {
    let optype = ''
    if (name === 'SiteMaster') {
      optype = 'Site' // commented for transovative changes
      // optype = 'SiteNew';
    } else if (name === 'activatedeactivatesite') {
      optype = 'activatedeactivatesite'
    }
    const activatedeactivatesite = {
      siteid: requestjson.siteid,
      servicetype: this.User.CompanyCode,
      status: requestjson.status,
      OperationType: 'activatedeactivatesite',
      Action: 'edit'
    }
    const siteforAdd = {
      siteid: requestjson.location_code,
      sitename: requestjson.location_name,
      address: requestjson.site_address,
      branch: requestjson.branch_code,
      servicetype: requestjson.CompanyCode,
      client: requestjson.client_group_code,
      clientname: requestjson.ClientName,
      clientemail: requestjson.ContactPersonEmail,
      deploymentdate: requestjson.DeploymentDate,
      siteownercode: requestjson.site_owner_code,
      authorizedstrength: requestjson.authorizedstrength,
      clientmobile: requestjson.clientmobile,
      City: requestjson.Taluka,
      state: requestjson.state,
      Region: requestjson.Region,
      OperationType: 'site',
      Action: 'add'
    }
    const siteforedit = {
      siteid: requestjson.location_code,
      sitename: requestjson.location_name,
      address: requestjson.site_address,
      branch: requestjson.branch_code,
      servicetype: requestjson.CompanyCode,
      client: requestjson.client_group_code,
      clientname: requestjson.ClientName,
      clientemail: requestjson.ContactPersonEmail,
      deploymentdate: requestjson.DeploymentDate,
      siteownercode: requestjson.site_owner_code,
      guardingtype: requestjson.guardingtype,
      armedguards: requestjson.armedguards,
      unarmedguards: requestjson.unarmedguards,
      authorizedstrength: requestjson.authorizedstrength,
      clientmobile: requestjson.clientmobile,
      City: requestjson.Taluka,
      state: requestjson.state,
      Region: requestjson.Region,
      OperationType: 'site',
      Action: 'edit'
    }
    let d1 = {
    }
    const data = {
      requestJson: d1,
      UserId: this.User.UserId,
      OperationType: optype,
      UnitCode: id,
      UnitDescription: requestjson.location_name,
      DefaultReturnCode: res.DefaultReturnCode,
      DefaultMessage: res.DefaultMessage,
      ActionType: '',//this.Sitedatafrmview.EditSData ? 'Update' : 'Insert'
    }
    if (name === 'SiteMaster' && !this.Sitedatafrmview.EditSData) {
      data.requestJson = siteforAdd;
      data.ActionType = 'add_site';
    }
    else if (name === 'SiteMaster' && this.Sitedatafrmview.EditSData) {
      data.requestJson = siteforedit;
      data.ActionType = 'update_sitedetails';
    }
    else if (name === 'activatedeactivatesite') {
      data.requestJson = activatedeactivatesite;
      data.ActionType = 'activatedeactivatesite';
    }
    this.locationservice.Transovative_SubMasterApi_ConsumptionLogs(data).subscribe({
      next: (response) => {
        //this.close();
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error: any) => {
        this.isDisabled = false;
      },
    });
  }
  ValidateInput(event: KeyboardEvent, type: string) {
    const charCode = event.which ? event.which : event.keyCode;
    const input = (event.target as HTMLInputElement).value;
    const dotCount = input.split('.').length - 1;
    const minusCount = (input.match(/-/g) || []).length;
    const cursorPosition = (event.target as HTMLInputElement).selectionStart;

    if (type === 'Latitude') {
      // if (
      //   (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
      //   (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
      //   (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
      //   (minusCount > 0 && charCode === 45)
      // ) {
      //   event.preventDefault();
      //   return;
      // }
      // if (input.length >= 25) {
      //   event.preventDefault();
      //   return;
      // }
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) || // Not a number, decimal point, or minus
        (dotCount > 0 && charCode === 46) ||
        (charCode === 45 && cursorPosition !== 0) || // Minus sign not at the beginning
        (minusCount > 0 && charCode === 45) // More than one minus sign
      ) {
        event.preventDefault();
        return;
      }

      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
    }
    else if (type === 'NumandDec') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
      if (input.includes('.') && input.split('.')[1].length >= 2) {
        if (charCode >= 48 && charCode <= 57) {
          event.preventDefault();
          return;
        }
      }
    }
    else if (type === 'allowtwodigit') {
      if (
        (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) ||
        (dotCount > 0 && charCode === 46 && (cursorPosition !== null && cursorPosition <= input.indexOf('.') + 1)) ||
        (charCode === 45 && (cursorPosition !== null && cursorPosition !== 0)) ||
        (minusCount > 0 && charCode === 45)
      ) {
        event.preventDefault();
        return;
      }
      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
      if (input.includes('.') && input.split('.')[1].length >= 2) {
        if (charCode >= 48 && charCode <= 57) {
          event.preventDefault();
          return;
        }
      }
    }
    else if (type === 'allowNumber') {
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
        return;
      }

      if (input.length >= 25) {
        event.preventDefault();
        return;
      }
    }
  }

  OpenDesignationSummary(element: any) {
    if (this.common.PageRight.IsView) {
      const modalRef = this.modalService.open(DesignationWiseSummaryComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.InputData = {
        SelectType: 'D',
        RegionId: this.RegionId.toString(),
        BranchId: element.BranchMasterId,
        ZoneId: this.ZoneId.toString(),
        ClientId: element.ClientGroupMasterId,
        SiteId: element.SiteMasterId,
        SupervisorId: this.SiteOwnerId.toString(),
        AsOnDate: this.dateFormate.format(this.Date),
      };
    }
  }

  DetailSum(element: any) {
    if (this.common.PageRight.IsView) {
      this.router.navigate(['master/ViewAllocateManpowerNew/' + element.BranchMasterId + "/" + element.ClientGroupMasterId + "/" + element.SiteMasterId]);
    }
  }

  ValidateEmail(email: string) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  onFileSelected(event: any) {
    this.isDisabled = true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
    }
  }

  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    this.isDisabled = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'SiteAgreementDetail', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          this.SiteAgreementCopyAttachment = response.FileName;
          this.AttachmentUrl = response.Url;
          this.isDisabled = false;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  removeFile() {
    this.selectedFile = null;
    this.SiteAgreementCopyAttachment = '';
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.AttachmentUrl, '_blank');
  }

  loadbankdetail() {
    console.log(this.SiteBankId);
    if (this.SiteBankId == null) {
      this.BankName = '';
      this.AccountNumber = '';
      this.IFSCcode = '';
      this.BankBranchName = '';
    } else {
      console.log(this.Banks);
      if (this.Banks && this.Banks.length > 0) {
        const bank = this.Banks.find((e: any) => e.OurCompanyBankMasterID == this.SiteBankId);
        if (bank) {
          this.BankName = bank.BankName;
          this.AccountNumber = bank.AccountNo;
          this.IFSCcode = bank.IFSCCode;
          this.BankBranchName = bank.BranchName;
        }
      }
    }
  }

  onKeyPressNumbersOnly(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow only digits 0–9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  loadgroupdata() {
    if (this.SiteSubGroupMasterID) {
      if (this.SubGroups && this.SubGroups.length > 0) {
        const group = this.SubGroups.find((e: any) => e.SiteSubGroupMasterID == this.SiteSubGroupMasterID);
        if (group) {
          this.SiteGroupMasterID = group.SiteGroupMasterID;
        }
      }
    }
  }

  loadSubgroup() {
    if (this.SiteGroupMasterID == null) {
      this.FilteredSubGroups = [];
      this.SiteSubGroupMasterID = null;
    } else {
      this.FilteredSubGroups = this.SubGroups.filter((e: any) => e.SiteGroupMasterID == this.SiteGroupMasterID);
      this.SiteSubGroupMasterID = null;
    }
  }

  clientPocApplicableChange() {
    if(this.IsClientPOCApplicable){
      this.IsClientAttendanceInformationMail = this.IsClientAttendanceInformationMail ? !this.IsClientAttendanceInformationMail: this.IsClientAttendanceInformationMail;
    }
    if (this.common.CompanyParameterValue.IsESSAutoFillClientPOC) {
      if (this.IsClientPOCApplicable) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to auto fill this from contact person detail?'

        modalRef.result.then((result: any) => {
          if (result) {
            this.ClientPOCName = this.ContactPersonName;
            this.ClientPOCMailId = this.ContactPersonEmail;
            this.ClientPOCMobileNo = this.ContactPersonNo
          }
        }).catch(() => {

        });
      }
    }
  }

  internalPocApplicableChange() {
    if (this.common.CompanyParameterValue.IsESSAutoFillInternalPOC) {
      if (this.IsInternalPOCApplicable) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to auto fill this from site owner detail?'

        modalRef.result.then((result: any) => {
          if (result) {
            this.InternalPOCName = this.SiteOwnerName;
            this.InternalPOCMobileNo = this.SiteOwnerNumber;
            this.InternalPOCMailId = this.SiteOwnerEmail;
          }
        }).catch(() => {

        });
      }
    }
  }

  siteOwnerChange() {
    if (this.SiteOwnerId !== null) {
      let siteowner = this.SiteOwner.find((e: any) => e.SiteOwnerMasterID == this.SiteOwnerId);
      if (siteowner) {
        this.SiteOwnerName = siteowner.SiteOwnerName;
        this.SiteOwnerEmail = siteowner.EmailID;
        this.SiteOwnerNumber = siteowner.Phone;
      }
    }
  }

  clientOnlyInformationChange(){
    if(this.IsClientAttendanceInformationMail){
      this.IsClientPOCApplicable = this.IsClientPOCApplicable ? !this.IsClientPOCApplicable : this.IsClientPOCApplicable;
    }
  }
}